<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="animation__triangle">
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Индивидуализм</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">Каждый
                человек для&nbsp;нас
                самоценен. Мы&nbsp;уважаем и&nbsp;поддерживаем стремление сотрудников к&nbsp;самореализации</p>
            </div>
          </div>
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Отношение</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">Мы ценим открытые отношения и хорошее чувство юмора. Мы делимся экспертизой и дополняем друг друга</p>
            </div>
          </div>
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Движение</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">Мы&nbsp;живём энергией движения, непрерывного развития и&nbsp;совершенствования. Мы&nbsp;быстро осваиваем новые инструменты и&nbsp;эффективно используем их&nbsp;в&nbsp;нашей работе</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <individualism-background />

    <page-footer
      :next="{ name: 'relations' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import IndividualismBackground from '@/components/aboutSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'individualism',
  mixins: [RouteMixin],
  components: {
    IndividualismBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.individualism-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.individualism__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.individualism__subtitle', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.individualism-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
